import i18n from "i18next";
import { initReactI18next } from "react-i18next"
import locales from '@/locales/locales'
import antEnUS from 'antd-mobile/es/locales/en-US'
import antZhCN from 'antd-mobile/es/locales/zh-CN'
import antArSA from 'antd-mobile/es/locales/ar-SA'
import antTrTR from 'antd-mobile/es/locales/tr-TR'
import antPtBR from 'antd-mobile/es/locales/pt-BR'
import antIdID from 'antd-mobile/es/locales/id-ID'
import antRuRU from 'antd-mobile/es/locales/ru-RU'
import antUzUZ from '@/locales/antd-mobile/uz-UZ'
import antUrPk from '@/locales/antd-mobile/ur-PK'
import antFaIR from 'antd-mobile/es/locales/fa-IR'
import { storageUtil } from '@/utils';
import { getConfig } from '@/config'

const { getLocalStorage } = storageUtil
const conf = getConfig()

// 判断是否是 voca 项目
function isVoca() {
  if (['vocaDev', 'vocaTesting', 'vocaUat', 'vocaProd'].includes(conf.realEnv)) {
    return true
  }
  return false
}

/* 获取msg */
const getMsg = (locale: 'zh_CN' | 'en_US' | 'ar_SA' | 'tr_TR' | 'pt_BR' | 'id_ID' | 'ru_RU' | 'uz_UZ' | 'fa_IR' | 'ur_PK') => {
  const msg: { [key: string]: string } = {};
  
  // 中文取key
  if (locale === 'zh_CN') {
    Object.keys(locales).forEach((key) => {
      if (locales[key][locale]) {
        msg[key] = isVoca() ? locales[key][locale].replace(/(Hoby|hoby)/, 'Voca') : locales[key][locale];
      } else {
        msg[key] = isVoca() ? key.replace(/(Hoby|hoby)/, 'Voca') : key;
      }
    });
    return msg;
  }

  // 其他取value
  Object.keys(locales).forEach((localeKey: string) => {
    msg[localeKey] = isVoca() ? locales[localeKey][locale].replace(/(Hoby|hoby)/, 'Voca') : locales[localeKey][locale];
  });
  return msg;
};

// i18n的语言资源map
const resources = {
  zh: {
    translation: getMsg('zh_CN'),
  },
  en: {
    translation: getMsg('en_US'),
  },
  tr: {
    translation: getMsg('tr_TR'),
  },
  ar: {
    translation: getMsg('ar_SA'),
  },
  pt: {
    translation: getMsg('pt_BR'),
  },
  id: {
    translation: getMsg('id_ID'),
  },
  ru: {
    translation: getMsg('ru_RU'),
  },
  uz: {
    translation: getMsg('uz_UZ'),
  },
  fa: {
    translation: getMsg('fa_IR'),
  },
  ur: {
    translation: getMsg('ur_PK'),
  }
};

// antd-mobile的语言文件map
const antResources: { [key: string]: any } = {
  en: antEnUS,
  zh: antZhCN,
  ar: antArSA,
  tr: antTrTR,
  pt: antPtBR,
  id: antIdID,
  ru: antRuRU,
  uz: antUzUZ,
  fa: antFaIR,
  ur: antUrPk,
}

// -连接符语言转换为i18n语言
const lang2I18nMap: any = {
  'zh-CN': 'zh',
  'en-US': 'en',
  'ar-SA': 'vi',
  'tr-TR': 'tr',
  'pt-BR': 'pt',
  'id-ID': 'id',
  'ru-RU': 'ru',
  'uz-UZ': 'uz',
  'fa-IR': 'fa',
  'ur-PK': 'ur',
}

// 获取i18n的语言
export function getI18nLang() {
  const lang = getLocalStorage('language') || ''
  const systemLang = getSystemLang()
  return lang || lang2I18nMap[systemLang]
}

/**
 * 获取antd-mobile的语言文件
 * @returns 
 */
export function getAntLangFile() {
  const language: string = getI18nLang()
  console.log('language', antResources[language])
  return antResources[language] || antResources.en
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: getI18nLang(), // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

/**
 * 获取浏览器默认的语言，并转换为通用-连接符格式
 * @returns
 */
export function getSystemLang() {
  // @ts-ignore
  let lang = window.navigator.language || window.navigator.userLanguage || 'zh-CN'
  const map: any = {
    en: 'en-US',
  }
  // 如果不是-链接的，转为-链接的
  if (!lang.includes('-')) {
    if (map[lang]) {
      lang = map[lang]
    } else {
      lang = `${lang}-${lang.toUpperCase()}`
    }
  }
  return lang
}

export const langOptions = [
  { text: '中文', key: 'zh-CN' },
  { text: 'English', key: 'en-US' },
  { text: 'العربية', key: 'ar-SA' },
  { text: 'Türkçe', key: 'tr-TR' },
  { text: 'Português', key: 'pt-BR' },
  { text: 'Bahasa Indonesia', key: 'id-ID' },
  { text: 'Русский', key: 'ru-RU' },
  { text: "o'zbek", key: 'uz-UZ' },
  { text: 'فارسی', key: 'fa-IR' },
  { text: 'اردو', key: 'ur-PK' },
]
export type LangOption = typeof langOptions[0]

export const langActions = [
  { text: 'English', key: 'en' },
  { text: 'العربية', key: 'ar' },
  { text: 'Türkçe', key: 'tr' },
  { text: 'Português', key: 'pt' },
  { text: 'Bahasa Indonesia', key: 'id' },
  { text: 'Русский', key: 'ru' },
  { text: "o'zbek", key: 'uz' },
  { text: 'فارسی', key: 'fa' },
  { text: 'اردو', key: 'ur' },
]

export const t = i18n.t
export default i18n;
  